import xs from "xstream"
import dropRepeats from "xstream/extra/dropRepeats"
import * as R from "ramda"

import {dumper, nopListener} from "../utils"

const CALL_LIMIT = 50
const CHECK_DURATION = 1000

const callCheck = (() => {
  let lastCall = 0
  let callCount = 0
  return (e: any) => {
    const now = new Date().getTime()
    if (lastCall + CHECK_DURATION < now) {
      lastCall = now
      callCount = 1
      return e
    }
    if (callCount > CALL_LIMIT) {
      // eslint-disable-next-line no-console
      console.log(e)
      throw { message: `EXCEEDED CALL LIMIT ${CALL_LIMIT}` }
    }
    lastCall = now
    callCount += 1
    return e
  }
})()

export function makeStateStoreDriver(initState = {}, debug = false) {
  const listener = debug ? dumper : nopListener
	const source$ = xs.createWithMemory().startWith(initState)
  
  source$.addListener(nopListener("permanent state listener"))

	return (sink$) => {
		sink$
      .debug(callCheck)
			.fold( (state, changeState) => {
        try {
          return changeState(state);
        } catch (e) {
          console.log("makeStateStoreDriver:", e)
          return state
        }
			}, initState )
			.map( value => {
				source$.shamefullySendNext( value );
				return value;
			})
			.addListener(listener("makeStateStoreDriver"))
		return {
        select: (s:Array<string>) =>
          s
            ? source$
              .map(R.view(R.lensPath(s)))
              .compose(dropRepeats(R.equals))
              .remember()
            : source$
		}
	}
}
